import React from 'react';
import PropTypes from 'prop-types';

import { withStripes } from '@folio/stripes/core';

import NoPermissionMessage from '../no-permission-message';

const IfPermissionWrapper = ({
  stripes,
  perm,
  children,
}) => {
  const hasPermission = stripes.hasPerm(perm);

  if (!hasPermission) {
    return <NoPermissionMessage />;
  }

  return children;
};

IfPermissionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  perm: PropTypes.string.isRequired,
  stripes: PropTypes.shape({
    hasPerm: PropTypes.func.isRequired,
  }).isRequired,
};

export default withStripes(IfPermissionWrapper);
